export const accountsConstants = {
  GET_ACCOUNTS: 'GET_ACCOUNTS',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  APPROVE_ACCOUNT: 'APPROVE_ACCOUNT',
  SET_ACCOUNT_FIELD: 'SET_ACCOUNT_FIELD',
  SET_EDIT_ACCOUNT: 'SET_EDIT_ACCOUNT'
};

export default accountsConstants;
